import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { AssetDetailsDialogComponent } from '../asset-details-dialog/asset-details-dialog.component';
import { AssetsService } from '../assets.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-assests-details',
  templateUrl: './assests-details.component.html',
  styleUrls: ['./assests-details.component.scss']
})
export class AssestsDetailsComponent implements OnInit {

  displayedColumns: string[] = ['orcFusionBuildingCode', 'buildingName', 'minorCategoryName', 'blockNo', 'blockName', 'floorNo', 'roomType', 'roomNo', 'totalAssets', 'approveStatus'];
  dataAvailable = true;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  campusTablelist: any;
  assettabledetalis: any;
  ngOnInit(): void {
    this.Campuslist();

  }
  constructor(private spinner: NgxSpinnerService, public dialog: NgDialogAnimationService, private assetsservice: AssetsService) { }

  Campuslist() {
    this.spinner.show();
    this.assetsservice.getCampuslisttable().subscribe(
      {
        next: (res: any) => {
          this.campusTablelist = res;
          console.log('campusTablelist', this.campusTablelist);
          this.assettabledetalis = new MatTableDataSource(this.campusTablelist);
          this.assettabledetalis.sort = this.sort;
          this.assettabledetalis.paginator = this.paginator;
          this.dataAvailable = true;
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    )
  }

  pending() {
    const dialogRef = this.dialog.open(AssetDetailsDialogComponent, {
      direction: 'ltr',
      height: '100%',
      width: '35%',
      position: { right: '0px', top: '0px' },
      animation: { to: "left" },
      panelClass: 'responsive-dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'save') {
        this.Campuslist();
        console.log('result', result);
      }
    });
  }

  applyFilter(e: any) {
    const filterValue = (e.target as HTMLInputElement).value;
    this.assettabledetalis.filter = filterValue.trim().toLowerCase();
    console.log('filterValue', filterValue);
  }
}